// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "Care Diary",
    appLogoImage: require("@src/assets/images/logo/care-diary-icon.png")
      .default,
    menuLogo: require("@src/assets/images/logo/care-diary.png").default,
  },
  layout: {
    isRTL: false,
    // system | light | dark | bordered. "light" is today's semi-dark menu.
    // Missing localStorage follows this value (system = prefers-color-scheme).
    skin: "system",
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "hidden", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
